"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _mui = require("@ori-ui/mui");
var _favoritesHeart = require("@ori/favorites-heart");
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _searchPreviewProductContext = require("../../contexts/searchPreviewProductContext");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const Buttons = () => {
  const product = (0, _searchPreviewProductContext.useSearchPreviewProduct)();
  const {
    code,
    name,
    price,
    shades,
    shouldRenderQuickBuyButton,
    shouldRenderFavoritesButton,
    canBeSold,
    analyticsData,
    productListId,
    onQuickBuyButtonClick,
    onFavoritesButtonClick
  } = product;
  const theme = (0, _mui.useTheme)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  if (canBeSold && shouldRenderQuickBuyButton) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.QuickBuyButton, {
        "data-testid": `${getTestId(_constants.QUICK_BUY)}-${code}`,
        "aria-label": translations.quickBuy,
        currentProductCode: code,
        name: name,
        currentPrice: price?.currentFormatted ?? '',
        placement: analyticsData?.placement,
        position: analyticsData?.position,
        size: theme.responsiveLayout && !isMobile ? 'large' : 'medium',
        onQuickBuyButtonClick: onQuickBuyButtonClick ?? (0, _utils.getQuickBuyButtonOnClickHandler)(product, analyticsData)
      })
    });
  } else if (shouldRenderFavoritesButton) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_favoritesHeart.FavoritesHeartIconButton, {
      "aria-label": translations.favorites,
      code: code,
      "data-testid": `${getTestId(_constants.FAVORITE)}-${code}`,
      placement: analyticsData?.placement,
      position: analyticsData?.position,
      shades: shades ?? [],
      size: theme.responsiveLayout && !isMobile ? 'large' : 'medium',
      desktopSize: theme.responsiveLayout && !isMobile ? 'large' : 'medium',
      productListId: productListId,
      onClick: onFavoritesButtonClick
    });
  }
  return null;
};
exports.Buttons = Buttons;
